/*
<form id="gb-search-form">
		<label for="gb-search-input" class="ally-hidden">Searching for something?</label>
		<input type="text" id="gb-search-input" value="Searching for something?" />
		<button type="submit" id="gb-search-button"><span class="ally-hidden">Submit Search</span></button>
	</form>
*/
var SWSearch = { 
	Relocate: function() {
		var siteID = document.getElementById("sps-site-id").value;

		/* DON"T ADD FOR STAFF */
		if( siteID !== "83" ) {
			var searchListItem = document.createElement( "li" );
			searchListItem.classList.add( "sw-channel-item" );
			searchListItem.id = "gb-search-list-item";

			var searchIconLink = document.createElement( "a" );
			searchIconLink.classList.add( "gb-search-icon" );
			searchIconLink.setAttribute( "tabindex", "0" );

			var searchIcon = document.createElementNS( "http://www.w3.org/2000/svg", "svg" );
			/* searchIcon.id = "gb-search-icon"; */

			searchIcon.setAttribute( "data-name", "search-icon" );
			//searchIcon.setAttribute( "xmlns", "http://www.w3.org/2000/svg" );
			searchIcon.setAttribute( "viewBox", "-2 -2 24 24" );
			searchIcon.setAttribute( "height", "24" );
			searchIcon.setAttribute( "width", "24" );
			searchIcon.setAttribute( "version", "1.1" );

			var searchIconCircle = document.createElementNS( "http://www.w3.org/2000/svg", "circle" );
			searchIconCircle.setAttribute( "cx", "8.5" );
			searchIconCircle.setAttribute( "cy", "8.5" );
			searchIconCircle.setAttribute( "r", "8" );
			searchIconCircle.setAttribute( "fill", "none" );
			searchIconCircle.setAttribute( "stroke", "#FFFFFF" );
			searchIconCircle.setAttribute( "stroke-miterlimit", "10" );
			searchIconCircle.setAttribute( "stroke-width", "3px" );

			searchIcon.appendChild( searchIconCircle );

			var searchIconPath = document.createElementNS( "http://www.w3.org/2000/svg", "path" );
			searchIconPath.setAttribute( "fill", "none" );
			searchIconPath.setAttribute( "stroke", "#FFFFFF" );
			searchIconPath.setAttribute( "stroke-miterlimit", "10" );
			searchIconPath.setAttribute( "d", "M14 14.1l7.1 7.1" );
			searchIconPath.setAttribute( "stroke-width", "3px" );

			searchIcon.appendChild( searchIconPath );
			/* searchIcon.innerHTML = "<circle cx=\"8.5\" cy=\"8.5\" r=\"8\" fill=\"none\" stroke=\"#FFFFFF\" stroke-miterlimit=\"10\" stroke-width=\"3px\"></circle>" +
				"<path fill=\"none\" stroke=\"#FFFFFF\" stroke-miterlimit=\"10\" d=\"M14 14.1l7.1 7.1\" stroke-width=\"3px\"></path>"; */

			var searchForm = document.createElement( "form" );
			searchForm.id = "gb-search-form";

			var searchLabel = document.createElement( "label" );
			searchLabel.classList.add( "hidden-item" );
			searchLabel.setAttribute( "for", "gb-search-input" );
			searchLabel.innerText = "Search";

			var searchInput = document.createElement( "input" );
			searchInput.setAttribute( "type", "text" );
			searchInput.setAttribute( "placeholder", "Search" );
			searchInput.id = "gb-search-input";
			/* searchInput.value = "Search"; */

			var searchButton = document.createElement( "button" );
			searchButton.setAttribute( "type", "submit" );
			searchButton.id = "gb-search-button";

			var searchText = document.createElement( "img" );
			searchText.src = "https://www.spokaneschools.org/Static/globalassets/images/sw-mystart-search.png";
			searchText.setAttribute( "alt", "Search" );

			searchButton.insertAdjacentElement( "beforeend", searchText );

			searchForm.insertAdjacentElement( "beforeend", searchLabel );
			searchForm.insertAdjacentElement( "beforeend", searchInput );
			searchForm.insertAdjacentElement( "beforeend", searchButton );

			searchIconLink.insertAdjacentElement( "beforeend", searchIcon );

			searchListItem.insertAdjacentElement( "beforeend", searchIconLink );
			searchListItem.insertAdjacentElement( "beforeend", searchForm );

			$("#channel-navigation").append(searchListItem);

			/* Only set js events for desktop environment */
			if ($( "#mobile-menu").css( "display" ) === "none" )
			{
				$(searchIconLink).on( "click", function( event ) {
					event.stopImmediatePropagation();
					
					var siblings = $(this).siblings( "form" );

					if( siblings.hasClass( "active" ) ) {						
						siblings.removeClass( "active" );
					}
					else {
						siblings.addClass( "active" );
						siblings.find( "#gb-search-input" ).focus();
					}
				});

				$(searchForm).on( "mouseleave", function() {
					$(this).removeClass( "active");
					searchInput.value = "";
				});

				$(searchButton).on("blur", function () {
					$(searchForm).removeClass("active");
					searchInput.value = "";
				});
			}

			/* IF IS SCHOOL */
			if (siteID !== "8") {
				var searchLimit = document.createElement( "div" );
				searchLimit.id = "gb-search-options";

				var searchLimitLabel = document.createElement( "label" );
				searchLimitLabel.setAttribute( "for", "gb-search-limit" );
				searchLimitLabel.innerText = "Limit search to this site only";

				var searchLimitInput = document.createElement( "input" );
				searchLimitInput.id = "gb-search-limit";
				searchLimitInput.setAttribute( "type", "checkbox" );
				searchLimitInput.classList.add( "gb-search-option", "limit-results" );

				searchLimit.insertAdjacentElement( "beforeend", searchLimitLabel );
				searchLimit.insertAdjacentElement("beforeend", searchLimitInput);

				searchForm.insertAdjacentElement( "afterbegin", searchLimit );
			}

			CsCustomSearch.Init();
		}
	}
};

// GOOGLE SITE SPECIFIC SEARCH
// AUTHOR: BRENTON KELLY - CREATIVE DEVELOPMENT MANAGER - BLACKBOARD, INC.
// VERSION: 08.22.18

!function (i) { i.csSiteSpecificSearch = function (e) { var t = { siteID: 0, districtSiteID: 4, filterDistrictResults: !1 }; e && i.extend(t, e), -1 < window.location.href.indexOf("PageType=6") && (t.filterDistrictResults && t.districtSiteID == t.siteID || t.districtSiteID != t.siteID) && (i("#sw-content-layout-wrapper").children().last().remove(), i("#sw-content-layout-wrapper").append('<gcse:search queryparametername="SearchString" webSearchQueryAddition="more:pagemap:document-siteid:' + t.siteID + '"></gcse:search>')) } }(jQuery);


/* $(function() {
	CsCustomSearch.Init();
}); */

var CsCustomSearch = {
	// PROPERTIES
    "KeyCodes": { "tab": 9, "enter": 13, "esc": 27, "space": 32, "end": 35, "home": 36, "left": 37, "up": 38, "right": 39, "down": 40 },
    "SearchPlaceHolder": "Search",
	
    // METHODS
	"Init": function() {
    	this.Search();
        this.SearchOptions();
    },
    
    "Search": function() {
    	var _this = this;
        
    	$("#gb-search-button").click(function(e){
            if(_this.AllyClick(e)) {
                e.preventDefault();

                $("#gb-search-form").submit();
            }
		});

        $("#gb-search-form").submit(function(e){
			e.preventDefault();
			e.stopImmediatePropagation();
			
			var searchValue = $.trim($("#gb-search-input").val());
			
            if(searchValue != "" && searchValue != _this.SearchPlaceHolder) {
				var searchLocation = "www.spokaneschools.org"; //window.location.host;
				var siteID = $("#sps-site-id").val();

				if (searchLocation === "localhost" ) {
					searchLocation = "www.spokaneschools.org";
				}

				if( siteID === "-1" ) {
					siteID = "8";
				}

				window.location.href = "//" + searchLocation + "/site/Default.aspx?PageType=6&SiteID=" + siteID + "&SearchString=" + searchValue;
            }
        });
        
        $("#gb-search-input").focus(function() {
            if($.trim($(this).val()) == _this.SearchPlaceHolder) {
                $(this).val("");
			}
			
			_this.ToggleOptions( true );
        })/* .blur(function() {
			var searchValue = $.trim($(this).val());

			if (searchValue == "") {
				$(this).val(_this.SearchPlaceHolder);
				_this.ToggleOptions(false);
			}
			else if ( searchValue == _this.SearchPlaceHolder ) {
				_this.ToggleOptions(false);
			}
        }) */.keyup( function( e ) {
			if (_this.AllyClick(e)) {
				e.preventDefault();

				$("#gb-search-form").submit();
			}
		});
    },
    
    "SearchOptions": function() {
    	if(localStorage.csSiteSpecificSearch) {
            $(".gb-search-option.limit-results").attr("checked", "checked");

            $.csSiteSpecificSearch({
				"siteID": document.getElementById( "sps-site-id" ).value,
                "districtSiteID": 8,
                "filterDistrictResults": true
            });
        }

        $(".gb-search-option.limit-results").change(function(e) {
            if($(this).is(":checked")) {
                localStorage.setItem("csSiteSpecificSearch", true);
            } else {
                localStorage.removeItem("csSiteSpecificSearch");
            }
        });
	},
	
	"ToggleOptions": function( shouldShow ) {
		if( shouldShow ) {
			$( "#gb-search-options" ).addClass( "active" );
		}
		else {
			$("#gb-search-options").removeClass("active");
		}
	},
    
    "AllyClick": function(event) {
        if(event.type == "click") {
            return true;
        } else if(event.type == "keyup" && (event.keyCode == this.KeyCodes.enter)) {
            return true;
        } else {
            return false;
        }
    }
    
}